import { useIntl, defineMessages } from 'react-intl'

import { Select } from 'components/v2/Select'
import { GTPlaceV2TypeInput } from 'gql/types.generated'

const PLACES_LIST = [
  GTPlaceV2TypeInput.Hotel,
  GTPlaceV2TypeInput.Station,
  GTPlaceV2TypeInput.Mall,
  GTPlaceV2TypeInput.Supermarket,
  GTPlaceV2TypeInput.School,
  GTPlaceV2TypeInput.Office,
  GTPlaceV2TypeInput.PointOfInterest,
  GTPlaceV2TypeInput.Venue,
  GTPlaceV2TypeInput.Restaurant,
  GTPlaceV2TypeInput.ResidentialArea,
  GTPlaceV2TypeInput.ConvenienceStore,
  GTPlaceV2TypeInput.Sidewalk,
  GTPlaceV2TypeInput.ParkingLot,
  GTPlaceV2TypeInput.Attraction
]

const messages = defineMessages({
  selectPlaceType: {
    id: 'dictionary.selectPlaceType',
    defaultMessage: 'Select type'
  },
  [GTPlaceV2TypeInput.Station]: {
    id: 'places.types.station',
    defaultMessage: 'Station'
  },
  [GTPlaceV2TypeInput.Mall]: {
    id: 'places.types.mall',
    defaultMessage: 'Mall'
  },
  [GTPlaceV2TypeInput.PointOfInterest]: {
    id: 'places.types.pointOfInterest',
    defaultMessage: 'Point of interest'
  },
  [GTPlaceV2TypeInput.Attraction]: {
    id: 'places.types.attraction',
    defaultMessage: 'Attraction'
  },
  [GTPlaceV2TypeInput.Hotel]: {
    id: 'places.types.hotel',
    defaultMessage: 'Hotel'
  },
  [GTPlaceV2TypeInput.Supermarket]: {
    id: 'places.types.supermarker',
    defaultMessage: 'Supermarket'
  },
  [GTPlaceV2TypeInput.School]: {
    id: 'places.types.school',
    defaultMessage: 'School'
  },
  [GTPlaceV2TypeInput.Office]: {
    id: 'places.types.office',
    defaultMessage: 'Office'
  },
  [GTPlaceV2TypeInput.Venue]: {
    id: 'places.types.venue',
    defaultMessage: 'Venue'
  },
  [GTPlaceV2TypeInput.Restaurant]: {
    id: 'places.types.restaurant',
    defaultMessage: 'Restaurant'
  },
  [GTPlaceV2TypeInput.ResidentialArea]: {
    id: 'places.types.residential_area',
    defaultMessage: 'Residential area'
  },
  [GTPlaceV2TypeInput.ConvenienceStore]: {
    id: 'places.types.convenience_store',
    defaultMessage: 'Convenience store'
  },
  [GTPlaceV2TypeInput.Sidewalk]: {
    id: 'places.types.sidewalk',
    defaultMessage: 'Sidewalk'
  },
  [GTPlaceV2TypeInput.ParkingLot]: {
    id: 'places.types.parking_lot',
    defaultMessage: 'Parking lot'
  }
})

export const SelectPlaceType = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    <Select {...props}>
      <option value="">{intl.formatMessage(messages.selectPlaceType)}</option>

      {PLACES_LIST.map((type): TSFixMe => {
        return (
          <option value={type} key={type}>
            {intl.formatMessage(messages[type])}
          </option>
        )
      })}
    </Select>
  )
}
